import { useDayPicker } from 'react-day-picker'

import { isMonthValid } from '../../helpers/isNextMonthAvailable'

import styles from '../DatePicker.module.scss'

import ArrowIcon from '../../assets/arrow.svg'

interface Props {
    selectedMonth: Date
    disableFutureDates?: boolean
}

export const NextMonthButton = ({ selectedMonth, disableFutureDates = true }: Props) => {
    const { goToMonth, nextMonth } = useDayPicker()

    const handleClick = () => nextMonth && goToMonth(nextMonth)

    const checkIsDisabled = () => {
        if (!disableFutureDates) return false

        return selectedMonth && !isMonthValid(selectedMonth)
    }
    const isDisabled = checkIsDisabled()

    return (
        <button className={styles.nextMonthButton} disabled={isDisabled} onMouseUp={handleClick}>
            <ArrowIcon />
        </button>
    )
}
